module.exports = __webpack_public_path__ + "static/media/dashboard-crypto.44536265.png";